import { graphql } from "@generated/client";
import {
    type CreateManyVersionsInput,
    type CreateVersionInput,
    type DocumentVersionPatch,
    type GetLastVersionByDocumentUrlQuery,
    type MutationUpdateDocumentVersionCheckArgs,
} from "@generated/client/graphql";
import { AccessHeadersHolder } from "../AccessHeadersHolder";
import { graphqlClientKoyeb } from "../clients";

const GetLastVersionByDocumentUrlQuery = graphql(`
    query getLastVersionByDocumentUrl($documentUrl: String!) {
        lastVersion(url: $documentUrl) {
            id
            lastEditedAt
            finalFile {
                signedUrl
                name
                extension
            }

            withEditor
            status
            document {
                id
                description
                name
                type
                cmsDocumentId
                tier
                uniqueUrl
                tier
                theme {
                    id
                    name
                }
                children {
                    name
                    type
                    uniqueUrl
                    lastVersion {
                        status

                        finalFile {
                            signedUrl
                        }
                    }
                }
                parents {
                    name
                    type
                    uniqueUrl
                    lastVersion {
                        status

                        finalFile {
                            signedUrl
                        }
                    }
                }
                hasAiValidation
            }
            checks {
                checkType
                checked
                id
            }
            status
            aiDocumentChecks {
                checks {
                    name
                    success
                    motivation
                }
                comment
            }
        }
    }
`);

const UpdateVersionCheckMutation = graphql(`
    mutation UpdateVersionCheck(
        $id: String!
        $set: DocumentVersionCheckPatch!
    ) {
        updateDocumentVersionCheck(id: $id, set: $set) {
            id
            checkType
            checked
        }
    }
`);

const UpdateVersionMutation = graphql(`
    mutation UpdateVersion($versionId: String!, $patch: DocumentVersionPatch!) {
        updateDocumentVersion(id: $versionId, set: $patch) {
            id
        }
    }
`);

const CreateVersionMutation = graphql(`
    mutation CreateVersion($documentId: String!, $input: CreateVersionInput) {
        createVersion(id: $documentId, input: $input) {
            id
        }
    }
`);

const CreateManyVersionsMutation = graphql(`
    mutation createManyVersions($set: CreateManyVersionsInput!) {
        createManyVersions(set: $set) {
            id
        }
    }
`);

export const checkDocumentVersionMutation = graphql(`
    mutation checkDocumentVersion($versionId: String!) {
        aiCheckVersion(versionId: $versionId) {
            checks {
                name
                success
                motivation
            }
            comment
        }
    }
`);

export class GraphQLVersionRepository {
    async create({
        documentId,
        input,
    }: {
        documentId: string;
        input: CreateVersionInput;
    }) {
        return graphqlClientKoyeb.request(
            CreateVersionMutation,
            { documentId, input },
            await AccessHeadersHolder.getHeaders(),
        );
    }

    async createMany({ documentVersions }: CreateManyVersionsInput) {
        return graphqlClientKoyeb.request(
            CreateManyVersionsMutation,
            { set: { documentVersions } },
            await AccessHeadersHolder.getHeaders(),
        );
    }
    getLastByDocumentURL = async (
        documentUrl: string,
    ): Promise<GetLastVersionByDocumentUrlQuery> =>
        graphqlClientKoyeb.request(
            GetLastVersionByDocumentUrlQuery,
            { documentUrl },
            await AccessHeadersHolder.getHeaders(),
        );
    async update({ id, patch }: { id: string; patch: DocumentVersionPatch }) {
        return graphqlClientKoyeb.request(
            UpdateVersionMutation,
            { versionId: id, patch },
            await AccessHeadersHolder.getHeaders(),
        );
    }

    async updateVersionCheck({
        id,
        set,
    }: MutationUpdateDocumentVersionCheckArgs) {
        return graphqlClientKoyeb.request(
            UpdateVersionCheckMutation,
            { id, set },
            await AccessHeadersHolder.getHeaders(),
        );
    }

    async aiCheck(versionId: string) {
        return graphqlClientKoyeb.request(
            checkDocumentVersionMutation,
            { versionId },
            await AccessHeadersHolder.getHeaders(),
        );
    }
}
